import React from 'react'
import { Popover } from 'antd'
import { TransitionSelector, TransitionDisplay } from '../Transition'

const SceneTransition = ({ sceneId, position, transitionType, handleTransitionSelect }) => {
    return (
        <div className={`transition-wrapper ${position}-transition`}>
            <Popover
                content={
                    <TransitionSelector
                        onSelect={type => handleTransitionSelect(sceneId, position, type)}
                        currentTransition={transitionType}
                    />
                }
                trigger="hover"
                placement="right"
            >
                <div className="transition-trigger">
                    <TransitionDisplay
                        type={transitionType}
                        onRemove={() => handleTransitionSelect(sceneId, position, null)}
                    />
                </div>
            </Popover>
        </div>
    );
};

export default SceneTransition;